import { checkIfDressingIngredient } from './check-if-dressing-ingredient';

import type { Modification } from '../../types';

export function checkIfNonDressingIngredient(modification: Modification) {
  return !checkIfDressingIngredient(modification);
}
